import { useEffect, useState } from 'react';
import {
  getCachedSclaApplicationYears,
  loadSclaApplicationYears,
  SclaApplicationYears,
} from '../api/getSclaApplicationYears';

export default function useSclaApplicationYears() {
  const [data, setData] = useState<SclaApplicationYears | null>(
    getCachedSclaApplicationYears,
  );
  const [error, setError] = useState(false);

  useEffect(() => {
    let mounted = true;
    loadSclaApplicationYears()
      .then(result => {
        if (!mounted) return;
        setData(result);
        setError(false);
      })
      .catch(() => {
        if (!mounted) return;
        setError(true);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return {
    data,
    error,
    isLoading: !data && !error,
  };
}
